import { cacheDom } from '../utils/QuerySelectors.js'
import { updateCart, getCartUpsells } from '../utils/Cart.js'
import { money } from '../utils/helpers.js'

const dom = {}
const qs = {
  opener: 'data-opener',
  cartTotal: 'data-cart-total',
  cartSavings: 'data-cart-savings',
  originSavings: 'data-origin-savings',
}
const qsAll = {
  sections: 'data-cart',
  qtyDowns: 'data-minus',
  qtyUps: 'data-plus',
  removeBtns: 'data-item-remove',
  upsellWrappers: 'data-upsells',
}
const setCart = (element) => {
  const updates = {}
  updates[element.dataset.variantId] = element.dataset.qty
  updateCart(null, updates, false, true)
}

const initSection = (section) => {
  const opener = section.querySelector(`[${qs.opener}]`)
  const upsellWrappers = section.querySelectorAll(`[${qsAll.upsellWrappers}]`)
  const qtyDowns = section.querySelectorAll(`[${qsAll.qtyDowns}]`)
  const qtyUps = section.querySelectorAll(`[${qsAll.qtyUps}]`)
  const removeBtns = section.querySelectorAll(`[${qsAll.removeBtns}]`)
  if (opener) {
    opener.addEventListener('click', () => {
      section.classList.toggle('cart-show')
    })
  }

  qtyDowns.forEach((qtyDown) => qtyDown.addEventListener('click', () => setCart(qtyDown)))
  qtyUps.forEach((qtyUp) => qtyUp.addEventListener('click', () => setCart(qtyUp)))
  removeBtns.forEach((removeBtn) => removeBtn.addEventListener('click', () => setCart(removeBtn)))
  if (upsellWrappers.length > 0) {
    getCartUpsells((upsells) => {
      console.log('upsells', upsells)
      upsells.forEach((upsell, index) => {
        if (index < 4) {
          upsellWrappers.forEach(
            (upsellWrapper) =>
              (upsellWrapper.innerHTML += `<div class="h-full" product-tile variant='${JSON.stringify(
                upsell.variant,
              ).replaceAll("'", '’')}' product='${JSON.stringify(upsell.product).replaceAll("'", '’')}'></div>`),
          )
        }
      })
      window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
    })
  }
  setInterval(() => {
    const appElement = document.querySelector('.docapp-coupon-input--savings .buckscc-money')
    if (appElement) {
      let savings = parseInt(dom.originSavings.dataset.originSavings)
      let total = window.normalCart.items_subtotal_price
      savings += parseInt(appElement.dataset.geolizrPrice) || 0
      total -= parseInt(appElement.dataset.geolizrPrice) || 0
      dom.cartSavings.innerHTML = `$ ${money(savings)}`
      dom.cartTotal.innerHTML = `$ ${money(total)}`
    }
  }, 500)
}

export const setupCart = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => initSection(section))
}
